export default "__VITE_ASSET__7a853be7__"